"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddressSearchInput = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _trimStart = _interopRequireDefault(require("lodash/trimStart"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Button = require("../../elements/button/Button");
var _ChevronRight24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/ChevronRight24PxOutlined"));
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _addressSearch = require("../../form/configs/addressSearch");
var _addressSearchActions = require("../../redux/actions/addressSearch/addressSearchActions");
var _env = _interopRequireDefault(require("../../utils/env/env"));
var _scrollTo = require("../../utils/scroll/scrollTo");
var _LoadingSpinner = require("../loading-spinner/LoadingSpinner");
var _addressSearchInputModule = _interopRequireDefault(require("./address-search-input.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AddressSearchInput = exports.AddressSearchInput = /*#__PURE__*/function (_Component) {
  function AddressSearchInput() {
    var _this;
    _classCallCheck(this, AddressSearchInput);
    _this = _callSuper(this, AddressSearchInput);
    /* eslint-disable-next-line react/sort-comp */
    _defineProperty(_this, "handleScreenSizeChange", function () {
      _this.setShouldScrollOnFocus(_this.windowMatchMedia.matches);
    });
    _defineProperty(_this, "setShouldScrollOnFocus", function (bool) {
      _this.setState({
        shouldScrollOnFocus: bool
      });
    });
    _defineProperty(_this, "findAddress", function (_ref) {
      var searchTerm = _ref.searchTerm,
        containerId = _ref.containerId;
      var _this$props = _this.props,
        addressId = _this$props.addressId,
        addressSearchInputId = _this$props.addressSearchInputId,
        addressSearch = _this$props.addressSearch,
        getLoqateMocks = _this$props.getLoqateMocks,
        onLoqateSearch = _this$props.onLoqateSearch,
        shouldMock = _this$props.shouldMock,
        onLoqateNetworkTimeoutCallback = _this$props.onLoqateNetworkTimeoutCallback,
        jlpid = _this$props.jlpid;
      addressSearch({
        addressId: addressId,
        addressSearchInputId: addressSearchInputId,
        containerId: containerId,
        getLoqateMocks: getLoqateMocks,
        onLoqateSearchCallback: onLoqateSearch,
        searchTerm: searchTerm,
        shouldMock: shouldMock,
        onLoqateNetworkTimeoutCallback: onLoqateNetworkTimeoutCallback,
        jlpid: jlpid
      });
    });
    _defineProperty(_this, "getAddress", function (resultId) {
      var _this$props2 = _this.props,
        addressId = _this$props2.addressId,
        addressSearchInputId = _this$props2.addressSearchInputId,
        onLoqateSearch = _this$props2.onLoqateSearch,
        getLoqateMocks = _this$props2.getLoqateMocks,
        selectAddressResult = _this$props2.selectAddressResult,
        shouldMock = _this$props2.shouldMock,
        validateLoqateAddress = _this$props2.validateLoqateAddress,
        onLoqateNetworkTimeoutCallback = _this$props2.onLoqateNetworkTimeoutCallback,
        jlpid = _this$props2.jlpid,
        replaceGbTerritoryCountryCodes = _this$props2.replaceGbTerritoryCountryCodes,
        combineExtraAddressLines = _this$props2.combineExtraAddressLines;
      selectAddressResult({
        addressId: addressId,
        addressSearchInputId: addressSearchInputId,
        onLoqateSearchCallback: onLoqateSearch,
        id: resultId,
        shouldMock: shouldMock,
        validateLoqateAddress: validateLoqateAddress,
        getLoqateMocks: getLoqateMocks,
        onLoqateNetworkTimeoutCallback: onLoqateNetworkTimeoutCallback,
        jlpid: jlpid,
        replaceGbTerritoryCountryCodes: replaceGbTerritoryCountryCodes,
        combineExtraAddressLines: combineExtraAddressLines
      });
    });
    _defineProperty(_this, "windowClickListener", function (event) {
      if (_this.containerRef && !_this.containerRef.current.contains(event.target)) {
        _this.setState({
          showPrompt: false
        });
      }
    });
    _defineProperty(_this, "onKeyDown", function (e) {
      if (_this.inputAndResultsRef && !_this.inputAndResultsRef.current.contains(document.activeElement)) {
        _this.setState({
          showPrompt: false
        });
      }
      if (_this.state.showResults) {
        if (e.keyCode === AddressSearchInput.ARROW_KEY_UP || e.keyCode === AddressSearchInput.ARROW_KEY_DOWN) {
          e.preventDefault();
        }
      }
    });
    _defineProperty(_this, "debouncedFindAddress", (0, _debounce["default"])(_this.findAddress, 500));
    _defineProperty(_this, "onChange", function (event) {
      var value = (0, _trimStart["default"])((0, _get["default"])(event, 'target.value', ''));
      var onChange = _this.props.onChange;
      onChange(event);
      if (value.length >= 3) {
        _this.debouncedFindAddress({
          searchTerm: value
        });
        _this.setState({
          showPrompt: true,
          showResults: true
        });
      } else {
        _this.debouncedFindAddress.cancel();
        _this.setState({
          showPrompt: true,
          showResults: false
        });
      }
    });
    _defineProperty(_this, "resultsListOnKeyUpHandler", function (e) {
      var activeElement;
      if (document.activeElement.tagName === 'BUTTON') {
        activeElement = document.activeElement.parentNode;
      } else if (document.activeElement.tagName === 'LI') {
        activeElement = document.activeElement;
      }
      var dataTestIdValue = activeElement.attributes['data-testid'].value;
      if (dataTestIdValue === 'address-search-results-list-item' || dataTestIdValue === 'address-search-enter-address-list-button') {
        if (e.keyCode === AddressSearchInput.ARROW_KEY_DOWN) {
          if (activeElement.nextSibling) {
            // use firstElementChild to select button within li so user can hit enter
            activeElement.nextSibling.firstElementChild.focus();
          }
        } else if (e.keyCode === AddressSearchInput.ARROW_KEY_UP) {
          if (activeElement.previousSibling) {
            // use firstElementChild to select button within li so user can hit enter
            activeElement.previousSibling.firstElementChild.focus();
          }
        }
      }
    });
    _defineProperty(_this, "onFocus", function () {
      var preventLoqateScroll = _this.props.preventLoqateScroll;
      var shouldScrollOnFocus = _this.state.shouldScrollOnFocus;
      var inputValue = (0, _get["default"])(_this, 'inputRef.current.input.value', '');
      _this.setState({
        showPrompt: true
      });
      if (inputValue.length >= 3) {
        _this.setState({
          showResults: true
        });
      }
      if (!preventLoqateScroll && shouldScrollOnFocus) {
        (0, _scrollTo.scrollToElement)("[form=\"".concat(_addressSearch.ADDRESS_SEARCH_FORM_ID, "\"]"), false);
      }
    });
    _defineProperty(_this, "onSelect", function (item) {
      var Type = item.Type,
        Id = item.Id;
      if (Type !== 'Address') {
        _this.scrollToTopOfList();
        _this.findAddress({
          containerId: Id
        });
      } else {
        _this.getAddress(Id);
      }
    });
    _defineProperty(_this, "getHighlightedElement", function (string, highlights, itemId) {
      // Turn loqate's '0-3,5-6' into ['0', '3', '5', 6]
      var ranges = highlights.split(',').reduce(function (acc, set) {
        var parsedHighlightSet = set.split('-');
        acc.push.apply(acc, _toConsumableArray(parsedHighlightSet));
        return acc;
      }, []);
      return ranges.map(function (range, i) {
        var id = "".concat(i, "-").concat(itemId);
        var openingSegment;
        if (i === 0) {
          if (range !== 0) {
            // String doesn't start within a highlight range so capture everything from
            // the start of the string to the first highlight range
            openingSegment = /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
              children: string.substring(0, range)
            });
          }
        }
        var segmentStart = range;
        var segmentEnd = ranges[i + 1]; // will return undefined if no subsequent range exists, i.e., the rest of the string
        var segment = string.substring(segmentStart, segmentEnd);
        if (i % 2 === 0) {
          // Segment index is within a highlight range
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
            children: [openingSegment, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: _addressSearchInputModule["default"]['c-results__list__item__button__text__highlight'],
              children: segment
            })]
          }, id);
        }
        // Segment index is not within a highlight range
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
          children: [openingSegment, segment]
        }, id);
      });
    });
    _defineProperty(_this, "getHighlightedLabels", function (item) {
      var Description = item.Description,
        Highlight = item.Highlight,
        text = item.Text,
        itemId = item.Id;
      var highlightedDescription = Description;
      var highlightedText = text;
      if ((0, _isString["default"])(Highlight)) {
        var splitHighlights = Highlight.split(';');
        var textFieldHighlights = splitHighlights[0];
        var descriptionFieldHighlights = splitHighlights[1];
        if ((0, _isString["default"])(Description) && descriptionFieldHighlights && descriptionFieldHighlights.length) {
          highlightedDescription = _this.getHighlightedElement(Description, descriptionFieldHighlights, itemId);
        }
        if ((0, _isString["default"])(text) && textFieldHighlights && textFieldHighlights.length) {
          highlightedText = _this.getHighlightedElement(text, textFieldHighlights, itemId);
        }
      }
      return {
        highlightedDescription: highlightedDescription,
        highlightedText: highlightedText
      };
    });
    _defineProperty(_this, "getLabel", function (item) {
      var Description = item.Description,
        Type = item.Type;
      var _this$getHighlightedL = _this.getHighlightedLabels(item),
        highlightedDescription = _this$getHighlightedL.highlightedDescription,
        highlightedText = _this$getHighlightedL.highlightedText;
      if (Type === 'Postcode') {
        if ((0, _isString["default"])(Description)) {
          var description = Description.split('-')[0].trim();
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [description, ", ", highlightedText]
          });
        }
        return highlightedText;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [highlightedText, ", ", highlightedDescription]
      });
    });
    _defineProperty(_this, "getPostcodeAddressCount", function (item) {
      var Description = item.Description;
      if ((0, _isString["default"])(Description)) {
        var splitText = Description.split('-');
        return splitText[splitText.length - 1].trim();
      }
      return '';
    });
    _defineProperty(_this, "handleBackToResultsClick", function () {
      var previousSearchTerm = _this.props.previousSearchTerm;
      _this.findAddress({
        searchTerm: previousSearchTerm
      });
    });
    _defineProperty(_this, "scrollToTopOfList", function () {
      var input = document.querySelector('[data-testid="address-search-input"]');
      var list = document.querySelector('[data-scroll="address-search-results-list"]');
      if (list && input) {
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    });
    _defineProperty(_this, "getListItemClassnames", function (item) {
      return (0, _classnames["default"])(_addressSearchInputModule["default"]['c-results__list__item'], _defineProperty({}, _addressSearchInputModule["default"]['c-results__list__item__container'], item.Type !== 'Address'));
    });
    _defineProperty(_this, "handleEnterAddressManuallyTimeoutClick", function () {
      var _this$props3 = _this.props,
        onEnterManualAddress = _this$props3.onEnterManualAddress,
        onLoqateTimeoutEnterAddressManuallyCallback = _this$props3.onLoqateTimeoutEnterAddressManuallyCallback;
      onEnterManualAddress();
      onLoqateTimeoutEnterAddressManuallyCallback();
    });
    _defineProperty(_this, "renderEnterManualAddressButton", function (text) {
      var _this$props4 = _this.props,
        loqateAddressSearchCallActive = _this$props4.loqateAddressSearchCallActive,
        onEnterManualAddress = _this$props4.onEnterManualAddress;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
        className: _addressSearchInputModule["default"]['c-enter-manual-address-button'],
        "data-testid": "address-search-address-not-in-list-button",
        disabled: loqateAddressSearchCallActive,
        onClick: onEnterManualAddress,
        small: true,
        IconComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronRight24PxOutlined["default"], {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: text
        })
      });
    });
    _defineProperty(_this, "renderSearchActions", function () {
      var extraSearchAction = _this.props.extraSearchAction;
      if (!extraSearchAction) {
        return _this.renderEnterManualAddressButton('Enter address manually');
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        "data-testid": "address-search-input-actions",
        children: [extraSearchAction, " or", ' ', _this.renderEnterManualAddressButton('enter address manually')]
      });
    });
    _this.containerRef = /*#__PURE__*/(0, _react.createRef)();
    _this.inputAndResultsRef = /*#__PURE__*/(0, _react.createRef)();
    _this.inputRef = /*#__PURE__*/(0, _react.createRef)();
    _this.state = {
      showPrompt: false,
      showResults: false,
      shouldScrollOnFocus: false
    };
    return _this;
  }
  _inherits(AddressSearchInput, _Component);
  return _createClass(AddressSearchInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/223
      /* eslint-disable-next-line no-shadow */
      var _this$props5 = this.props,
        loqateApiKey = _this$props5.loqateApiKey,
        setLoqateApiKey = _this$props5.setLoqateApiKey;
      window.addEventListener('click', this.windowClickListener);
      window.addEventListener('keydown', this.onKeyDown);
      this.windowMatchMedia = window.matchMedia('(max-width: 768px)');
      this.setShouldScrollOnFocus(this.windowMatchMedia.matches);
      this.windowMatchMedia.addListener(this.handleScreenSizeChange);
      setLoqateApiKey(loqateApiKey);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.windowClickListener);
      window.removeEventListener('keydown', this.onKeyDown);
      if (this.windowMatchMedia) {
        this.windowMatchMedia.removeListener(this.handleScreenSizeChange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        showPrompt = _this$state.showPrompt,
        showResults = _this$state.showResults;
      var _this$props6 = this.props,
        className = _this$props6.className,
        id = _this$props6.id,
        loqateAddressSearchCallActive = _this$props6.loqateAddressSearchCallActive,
        name = _this$props6.name,
        networkTimeoutOccured = _this$props6.networkTimeoutOccured,
        onEnterManualAddress = _this$props6.onEnterManualAddress,
        overmatchTimeoutErrorOccured = _this$props6.overmatchTimeoutErrorOccured,
        results = _this$props6.results,
        showBackToResultsButton = _this$props6.showBackToResultsButton,
        value = _this$props6.value;
      var timeoutOccured = networkTimeoutOccured || overmatchTimeoutErrorOccured;
      var resultsContainerClassnames = (0, _classnames["default"])(_addressSearchInputModule["default"]['c-results'], _defineProperty({}, _addressSearchInputModule["default"]['c-results--loading'], loqateAddressSearchCallActive));
      var promptTextClassnames = (0, _classnames["default"])(_addressSearchInputModule["default"]['c-results__list__item__text'], _defineProperty({}, _addressSearchInputModule["default"]['c-results__list__item__text--timeout'], timeoutOccured));
      var promptText;
      if (networkTimeoutOccured) {
        promptText = 'Keep typing or try another part of the address';
      } else if (overmatchTimeoutErrorOccured) {
        promptText = 'Keep typing to make your search more specific';
      } else {
        promptText = 'Keep typing to display more results below';
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-testid": "address-search-input",
        ref: this.containerRef,
        "data-jlds": true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          "data-testid": "address-search-input-and-results-container",
          ref: this.inputAndResultsRef,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
            autoComplete: "off",
            className: className,
            id: id,
            name: name,
            onChange: this.onChange,
            onFocus: this.onFocus,
            ref: this.inputRef,
            value: value
          }), showPrompt && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [loqateAddressSearchCallActive && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _addressSearchInputModule["default"]['c-spinner'],
              "data-testid": "address-search-input-spinner",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingSpinner.LoadingSpinner, {
                size: "extra-large"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: resultsContainerClassnames,
              "data-testid": "address-search-input-results-container",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
                className: _addressSearchInputModule["default"]['c-results__list'],
                children: [!showBackToResultsButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                  className: _addressSearchInputModule["default"]['c-results__list__item__prompt'],
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    "data-testid": "address-search-prompt",
                    className: promptTextClassnames,
                    children: promptText
                  }), timeoutOccured && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
                    className: _addressSearchInputModule["default"]['c-results__list__item__timeout__button'],
                    "data-testid": "address-search-timeout-timeout-enter-address-button",
                    onClick: this.handleEnterAddressManuallyTimeoutClick,
                    small: true,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      className: _addressSearchInputModule["default"]['c-results__list__item__timeout__button__text'],
                      children: "or enter your address manually"
                    })
                  })]
                }), showResults && !(0, _isEmpty["default"])(results) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                  children: [showBackToResultsButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                    className: _addressSearchInputModule["default"]['c-results__list__item__back_to_results'],
                    "data-testid": "address-search-back-to-results-container",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                      className: _addressSearchInputModule["default"]['c-results__list__item__back_to_results__button'],
                      onClick: this.handleBackToResultsClick,
                      type: "button",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        className: _addressSearchInputModule["default"]['c-results__list__item__back_to_results__text'],
                        children: "Back to results"
                      })
                    })
                  }), results.map(function (item) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                      className: _this2.getListItemClassnames(item),
                      "data-scroll": "address-search-results-list",
                      "data-testid": "address-search-results-list-item",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                        className: _addressSearchInputModule["default"]['c-results__list__item__button'],
                        onClick: function onClick() {
                          return _this2.onSelect(item);
                        },
                        "data-testid": "address-search-result",
                        "data-cs-mask": true,
                        onKeyUp: _this2.resultsListOnKeyUpHandler,
                        type: "button",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                          className: _addressSearchInputModule["default"]['c-results__list__item__button__text'],
                          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                            children: _this2.getLabel(item)
                          }), item.Type === 'Postcode' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                            "data-testid": "address-search-result-postcode-address-count",
                            className: _addressSearchInputModule["default"]['c-results__list__item__button__text__address_count'],
                            children: _this2.getPostcodeAddressCount(item)
                          })]
                        })
                      })
                    }, item.Id);
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                    className: _addressSearchInputModule["default"]['c-results__list__item'],
                    "data-testid": "address-search-results-list-item",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
                      className: _addressSearchInputModule["default"]['c-results__list__item__button'],
                      "data-testid": "address-search-enter-address-list-button",
                      onClick: onEnterManualAddress,
                      onKeyUp: this.resultsListOnKeyUpHandler,
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        className: _addressSearchInputModule["default"]['c-results__list__item__button__text'],
                        children: "Enter address manually"
                      })
                    })
                  }, "enter-address-manually")]
                })]
              })
            })]
          })]
        }), this.renderSearchActions()]
      });
    }
  }]);
}(_react.Component);
_defineProperty(AddressSearchInput, "propTypes", {
  addressId: _propTypes["default"].string,
  addressSearchInputId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  loqateAddressSearchCallActive: _propTypes["default"].bool,
  loqateApiKey: _propTypes["default"].string,
  getLoqateMocks: _propTypes["default"].func,
  name: _propTypes["default"].string,
  previousSearchTerm: _propTypes["default"].string,
  results: _propTypes["default"].arrayOf(_propTypes["default"].object),
  shouldMock: _propTypes["default"].bool,
  showBackToResultsButton: _propTypes["default"].bool,
  preventLoqateScroll: _propTypes["default"].bool,
  overmatchTimeoutErrorOccured: _propTypes["default"].bool,
  networkTimeoutOccured: _propTypes["default"].bool,
  extraSearchAction: _propTypes["default"].element,
  replaceGbTerritoryCountryCodes: _propTypes["default"].bool,
  combineExtraAddressLines: _propTypes["default"].bool,
  //
  addressSearch: _propTypes["default"].func,
  onEnterManualAddress: _propTypes["default"].func,
  onLoqateSearch: _propTypes["default"].func,
  selectAddressResult: _propTypes["default"].func,
  setLoqateApiKey: _propTypes["default"].func,
  validateLoqateAddress: _propTypes["default"].func,
  onLoqateTimeoutEnterAddressManuallyCallback: _propTypes["default"].func,
  onLoqateNetworkTimeoutCallback: _propTypes["default"].func
});
_defineProperty(AddressSearchInput, "defaultProps", {
  addressId: '',
  addressSearchInputId: '',
  className: '',
  id: '',
  loqateAddressSearchCallActive: false,
  loqateApiKey: '',
  name: '',
  previousSearchTerm: '',
  results: undefined,
  shouldMock: _env["default"].isClientLocal,
  showBackToResultsButton: false,
  validateLoqateAddress: null,
  preventLoqateScroll: false,
  overmatchTimeoutErrorOccured: false,
  networkTimeoutOccured: false,
  extraSearchAction: undefined,
  replaceGbTerritoryCountryCodes: true,
  combineExtraAddressLines: false,
  //
  addressSearch: function addressSearch() {},
  getLoqateMocks: function getLoqateMocks() {},
  onEnterManualAddress: function onEnterManualAddress() {},
  onLoqateSearch: function onLoqateSearch() {},
  selectAddressResult: function selectAddressResult() {},
  setLoqateApiKey: function setLoqateApiKey() {},
  onLoqateTimeoutEnterAddressManuallyCallback: function onLoqateTimeoutEnterAddressManuallyCallback() {},
  onLoqateNetworkTimeoutCallback: function onLoqateNetworkTimeoutCallback() {}
});
_defineProperty(AddressSearchInput, "ARROW_KEY_UP", 38);
_defineProperty(AddressSearchInput, "ARROW_KEY_DOWN", 40);
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var name = ownProps.addressSearchInputId || 'addressSearch';
  return {
    loqateAddressSearchCallActive: state[name].loqateAddressSearchCallActive,
    results: state[name].results,
    showBackToResultsButton: state[name].showBackToResultsButton,
    previousSearchTerm: state[name].previousSearchTerm,
    overmatchTimeoutErrorOccured: state[name].overmatchTimeoutErrorOccured,
    networkTimeoutOccured: state[name].networkTimeoutOccured
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  addressSearch: _addressSearchActions.addressSearch,
  selectAddressResult: _addressSearchActions.selectAddressResult,
  setLoqateApiKey: _addressSearchActions.setLoqateApiKey
})(AddressSearchInput);